import * as Sentry from '@sentry/react';
// import { Integrations } from '@sentry/tracing';
// import history from 'routes/history';

export const init = () =>
  Sentry.init({
    release: process.env.REACT_APP_VERSION,
    dsn: process.env.REACT_APP_SENTRY_DSN,
    maxBreadcrumbs: 20,
    environment: process.env.REACT_APP_STAGE,
    debug: process.env.NODE_ENV === 'development',
    /**
     * One day we can use browser tracing when we self-host Sentry
     */
    // integrations: [
    //   new Integrations.BrowserTracing({
    //     // Can also use reactRouterV3Instrumentation or reactRouterV4Instrumentation
    //     routingInstrumentation: Sentry.reactRouterV5Instrumentation(history),
    //   }),
    // ],

    // // We recommend adjusting this value in production, or using tracesSampler
    // // for finer control
    // tracesSampleRate: 1.0,
  });

export const setUser = (userProps: Sentry.User) => Sentry.setUser(userProps);

export const reset = () => Sentry.configureScope(scope => scope.setUser(null));
